import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static targets = ["container", "template"];
  static values = { index: Number };

  add(event) {
    event.preventDefault();

    const nextPosition = this.containerTarget.children.length + 1;
    const content = this.templateTarget.innerHTML
      .replace(/NEW_PRODUCT_VARIANT_RECORD/g, this.indexValue)
      .replace(/value=""/g, `value="${nextPosition}"`); // Set position value

    this.containerTarget.insertAdjacentHTML("beforeend", content);

    // Set the position value in the hidden field
    const newVariant = this.containerTarget.lastElementChild;
    const positionField = newVariant.querySelector('input[name*="position"]');
    if (positionField) {
      positionField.value = nextPosition;
    }

    // Add required attribute to the description field since it was removed from template
    const descriptionInput = newVariant.querySelector('input[name*="description"]');
    if (descriptionInput) {
      descriptionInput.setAttribute("required", "required");
    }

    this.indexValue++;

    // Reinitialize sortable to include the new element
    this.sortable.destroy();
    this.initializeSortable();

    // Focus on the new description input
    if (descriptionInput) {
      descriptionInput.focus();
    }

    // Update remove button visibility
    this.updateRemoveButtonVisibility();
  }

  connect() {
    this.indexValue = this.containerTarget.children.length;
    this.initializeSortable();
    this.updateRemoveButtonVisibility();
  }

  initializeSortable() {
    this.sortable = Sortable.create(this.containerTarget, {
      animation: 150,
      handle: "[data-sortable-handle]",
      onEnd: () => {
        this.updatePosition();
        this.updateRemoveButtonVisibility();
      },
    });
  }

  remove(event) {
    event.preventDefault();

    const variant = event.target.closest("[data-variant]");
    if (variant) {
      // Check if this is an existing variant (has an ID) or a new one
      const idField = variant.querySelector('input[name*="[id]"]');
      const destroyField = variant.querySelector('input[name*="[_destroy]"]');

      if (idField && idField.value && destroyField) {
        // This is an existing variant - mark for destruction
        destroyField.value = "1";
        variant.style.display = "none";
      } else {
        // This is a new variant - just remove from DOM
        variant.remove();
      }

      this.updatePosition();
      this.updateRemoveButtonVisibility();
    }
  }

  updatePosition() {
    const allVariants = Array.from(this.containerTarget.querySelectorAll("[data-variant]"));
    const visibleVariants = allVariants.filter((variant) => {
      // Only update positions for variants that are not marked for destruction
      return variant.style.display !== "none";
    });

    visibleVariants.forEach((variant, index) => {
      const positionField = variant.querySelector('input[name*="position"]');
      if (positionField) {
        positionField.value = index + 1;
      }
    });
  }

  updateRemoveButtonVisibility() {
    const allVariants = Array.from(this.containerTarget.querySelectorAll("[data-variant]"));
    const visibleVariants = allVariants.filter((variant) => {
      // Check if variant is hidden (marked for destruction) or visible
      return variant.style.display !== "none";
    });
    const hasMultipleVariants = visibleVariants.length > 1;

    visibleVariants.forEach((variant) => {
      const removeButton = variant.querySelector('[data-action="product-variants#remove"]');
      if (removeButton) {
        if (hasMultipleVariants) {
          removeButton.classList.remove("hidden");
        } else {
          removeButton.classList.add("hidden");
        }
      }
    });
  }
}
